import { Typing } from './Typing'

export default Typing
